import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogService } from 'src/app/shared/services/dialog.service';

export interface registrarPago{
	fechaPago: Date;
	viaPago: string;
}

@Component({
  selector: 'registrar-pagos',
  templateUrl: './registrar-pagos.component.html',
  styleUrls: ['./registrar-pagos.component.css']
})
export class RegistrarPagosComponent implements OnInit {

  data: registrarPago = {
	  fechaPago: new Date,
	  viaPago: ''
  }

  constructor(
	public dialogRef: MatDialogRef<RegistrarPagosComponent>,
	public dialogService: DialogService
	) {}

  ngOnInit(): void {
  }

  confirmarRegistroPago() {
	this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
		if	(res == true) {
			this.dialogRef.close(this.data);
		}
	})
  }


}
